<template lang="html">
  <div id="buyvip">
    <div class="banner">
      <img v-if="!theme_switch" :src="static_img_url + 'pic/buyvip/dg-vip-banner.png?v=31'">
      <img v-else :src="static_img_url + 'pic/buyvip/dg-vip-banner-w.png?v=31'">
    </div>
    <div class="vip-container">
      <div class="pause">
        <div class="icon"></div>
        <p>尊敬的用户，动脉橙产品升级中，现暂停VIP会员购买功能，已购买的会员将继续提供相关服务，欢迎申请动脉橙企业智库机构版进行<span @click="isLoginOrVip2">免费试用</span></p>
        <div class="icon"></div>
      </div>
      <div class="vip-tabs">
        <div class="left">
          <p class="one">普通用户</p>
          <div class="two"></div>
          <p class="three">成为动脉橙用户，即刻洞见数据背后的真相与趋势</p>
          <div class="four" @click="handleClickTabBtn">
            <template v-if="user_key">
              立即体验
            </template>
            <template v-else>
              登陆/注册
            </template>
          </div>
        </div>
        <div class="right">
          <p class="one">VIP会员</p>
          <div class="two"></div>
          <p class="three">
            <span v-for="(item, index) in price_arr" :key="index">
              <span>￥</span><span>{{item.price}}</span><span>{{item.remark}}</span>
              <img v-if="index == 0" :src="!theme_switch ? static_img_url+'pic/buyvip/recommend_dark.png' : static_img_url+'pic/buyvip/recommend.png'">
              <img v-if="index == 3" :src="!theme_switch ? static_img_url+'pic/buyvip/new_dark.png' : static_img_url+'pic/buyvip/new_light.png'">
            </span>
          </p>
          <!-- <div class="four" @click="isLoginOrVip">
            <template  v-if="!user_key || (user.db_vip != '1' && user.vip != '1')">
              立即开通
            </template>
            <template v-if="user_key && (user.db_vip == '1' || user.vip == '1')">
              我要续费
            </template>
          </div> -->
          <div class="four" @click="isLoginOrVip2">
            立即开通
          </div>
        </div>
      </div>
      <div class="sub-title">
        <div></div>
        <p>会员专属特权</p>
        <div></div>
      </div>
      <div class="privilege-list">
        <div class="" v-for="(item, index) in privilege_list" :key="index">
          <img :src="static_img_url+'pic/buyvip/dg-'+(index+1) + (!theme_switch ? '' : '-l') +'.png'" />
          <div>
            <p>{{item.num}}</p>
            <p>{{item.text}}</p>
          </div>
        </div>
        <div class="last-li">更多权益 敬请期待</div>
      </div>
      <div class="sub-title">
        <div></div>
        <p>会员特权对比</p>
        <div></div>
      </div>
      <div class="module-two">
        <div class="module-two__area">
          <p>行业数据查询结果显示条数</p>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p>{{num_100}}<span>条</span></p><div><div class="length2" :class="{'animation':animation}"></div></div></div>
              <i class="iconfont">&#xe61d;</i>
              <div class="right"><p class="zanbu">不限制</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p1">查看数据显示条数</p>
            <p class="p2">并购事件、投资事件、公司、机构、政策、医院</p>
          </div>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p>{{num_5}}<span>条</span></p><div><div class="length1" :class="{'animation':animation}"></div></div></div>
              <i class="iconfont">&#xe61f;</i>
              <div class="right"><p class="zanbu">不限制</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p1">搜索结果查看条数</p>
            <p class="p2">并购事件、投资事件、公司、机构、政策、医院</p>
          </div>
        </div>
        <div class="module-two__area">
          <p>多种报告助您决策</p>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p>{{num_10}}<span>份/天</span></p><div><div class="length2" :class="{'animation':animation}"></div></div></div>
              <i class="iconfont">&#xe615;</i>
              <div class="right"><p class="zanbu">不限制</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p1">报告下载权益</p>
            <p class="p2">蛋壳研究院提供的免费报告</p>
          </div>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p>{{num_10}}<span>份/天</span></p><div><div class="length2" :class="{'animation':animation}"></div></div></div>
              <i class="iconfont">&#xe613;</i>
              <div class="right"><p class="zanbu">不限制</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p1">报告下载权益</p>
            <p class="p2">第三方提供的免费报告</p>
          </div>
        </div>
        <div class="module-two__area">
          <p>快讯情报查询结果显示条数</p>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p>{{num_20}}<span>条</span></p><div><div class="length3" :class="{'animation':animation}"></div></div></div>
              <i class="iconfont">&#xe61b;</i>
              <div class="right"><p class="zanbu">100条</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p1">查看数据显示条数</p>
            <p class="p2">实时追踪医疗行业动态事件</p>
          </div>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p>{{num_20}}<span>条</span></p><div><div class="length3" :class="{'animation':animation}"></div></div></div>
              <i class="iconfont">&#xe61f;</i>
              <div class="right"><p class="zanbu">100条</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p1">搜索结果查看条数</p>
            <p class="p2">精确查找您关注的信息</p>
          </div>
        </div>
        <div class="module-two__area">
          <p>免费畅读细分赛道深度报告</p>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p class="zanbu">暂不提供</p><div></div></div>
              <i class="iconfont">&#xe618;</i>
              <div class="right"><p class="zanbu">专属特权</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p2 br">我们会对大量信息进行快速分析、清洗和重组
                <br />经过资深编辑梳理甄别<br />
                力图将事件最新进展和相关影响清晰呈现</p>
          </div>
        </div>
        <div class="module-two__area">
          <p>免费查看投融资数据报表</p>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p class="zanbu">暂不提供</p><div></div></div>
              <i class="iconfont">&#xe61d;</i>
              <div class="right"><p class="zanbu">专属特权</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p2 br">针对不同用户，结合不同场景，打造丰富细节
              <br />给投融资数据一张“高级脸”
            </p>
          </div>
        </div>
        <!-- <div class="module-two__area">
          <p>线下活动</p>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p class="zanbu">暂不提供</p><div></div></div>
              <i class="iconfont">&#xe616;</i>
              <div class="right"><p class="zanbu">专属特权</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p2 br">不定期的资源对接及线下活动折扣优惠</p>
          </div>
        </div> -->
        <div class="module-two__area">
          <p>专属客服</p>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p class="zanbu">暂不提供</p><div></div></div>
              <i class="iconfont">&#xe61a;</i>
              <div class="right"><p class="zanbu">专属特权</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p2 br">会员专属客服为您“一对一”解答</p>
          </div>
        </div>
        <div class="module-two__area">
          <p>敬请期待</p>
          <div class="module-two__area-item">
            <div class="compare">
              <div class="left"><p class="zanbu">暂不提供</p><div></div></div>
              <i class="iconfont">&#xe617;</i>
              <div class="right"><p class="zanbu">专属特权</p><div><div :class="{'animation':animation}"></div></div></div>
            </div>
            <p class="p2 br">持续上新，逐步推出和完善行业数据信息
              <br />帮助您发现医疗产业变革当中的机会点</p>
          </div>
        </div>
      </div>
      <div class="sub-title">
        <div></div>
        <p>常见问题</p>
        <div></div>
      </div>
      <!-- <p class="vip-wechat-title"><i class="iconfont left">&#xe6be;</i>会员助手有话说<i class="iconfont right">&#xe6bf;</i></p> -->
      <div class="qa-list">
        <div class="qa-item" v-for="(item, index) in qa_list" :key="index" >
          <p>{{item.title}}</p>
          <p v-html="item.text"></p>
        </div>
      </div>
    </div>
    <!-- <div class="black-board">
      <p>敲黑板</p>
      <p>｜</p>
      <p>动脉会员服务为虚拟内容服务，请于购买前详细了解，无法定或约定事由概不退款，
最终解释权归动脉所有，敬请理解。</p>
    </div> -->
    <!-- <div class="fixed-float">
      <div class="fixed-area">
        <p>VIP全新升级<img :src="static_img_url + 'pic/buyvip/font-7.png?v=31'" />大权益等您享用~</p>
        <div class="fixed-buy">
          <p v-if="user_key && (user.db_vip == '1'||user.vip == '1')" @click="isLoginOrVip">
            我要续费
          </p>
          <p v-if="!user_key || (user.db_vip != '1' && user.vip != '1')" @click="isLoginOrVip">
            开通VIP会员
          </p>
          <p @click="isLoginOrVip2">
            开通VIP会员
          </p>
        </div>
      </div>
    </div> -->
    <Modal
      class="message-model"
      title="提示"
      v-model="message_model"
      ok-text="继续支付"
      cancel-text="取消"
      @on-ok="goPayNoPayOrder"
      @on-cancel="cancelOrder"
      >
      <p>亲，您当前有一个订单未完成，是否继续支付？</p>
    </Modal>
    <FinishInfoAndPay ref="finish_info_and_pay" :buytype ="'8'" :pricearr="price_arr" :orderuid="nopay_list.length != 0 ? nopay_list[0].uid:''" :flowprice="nopay_list.length != 0 ? nopay_list[0].pay_total:''"></FinishInfoAndPay>
  </div>
</template>

<script>
import FinishInfoAndPay from '../../components/FinishInfoAndPay'
import AddApply from '@/components/AddApply.vue'
import bus from 'js/bus'
import {
  getMeta,
  noPayOrderList,
  cancelOrder,
  addPuv
} from '../../service'
export default {
  inject: ['login', 'haddleApplyTry'],
  data() {
    return {
      privilege_list: [{
        num: '3万+',
        text: '行业数据查询'
      },
      {
        num: '1000+',
        text: '免费报告下载'
      },
      {
        num: '3万+',
        text: '快讯情报筛选'
      },
      {
        num: '100+',
        text: '细分赛道精选'
      },
      {
        num: '2万+',
        text: '投资数据可视化'
      },
      // {
      //   num: '100+',
      //   text: '线下活动'
      // },
      {
        num: '7*24',
        text: '专属客服'
      }
      ],
      qa_list: [{
        title: '免费用户和付费用户有什么区别？',
        text: '免费用户：查看部分数据；免费报告下载次数受限；搜索结果受限；<br/>付费用户：查看全量数据；免费报告下载次数无限制；搜索结果无限制；细分赛道精选内容；投融资可视化报表；专属客服等。'
      },
      {
        title: '会员什么时候开始生效？',
        text: '会员资格从付费成功后立即生效，在有效期内可享受动脉橙会员专享权益。'
      },
      {
        title: 'VIP付费会员到期后，可以如何操作？',
        text: 'VIP会员到期后，将自动降级为普通用户，不再享受VIP会员权益，您可以选择到期前或到期后购买VIP会员服务。'
      },
      {
        title: '会员身份可以多人使用吗？',
        text: '会员身份与支付的微信号绑定，仅限本人使用，不可转让。'
      },
      {
        title: '如何开具会员发票？',
        text: '登录网站后，个人中心—订单管理—勾选订单—点击“开具发票”申请开具发票，如您有其他需求，请在右下脚选择咨询客服，扫码后会有专人为您处理。'
      },
      {
        title: '购买会员服务后可以退款吗？',
        text: '抱歉！动脉橙会员是虚拟服务产品，暂不接受退款。如有特别原因，请联系客服。'
      },
      {
        title: '如何反馈意见、联系我们？',
        text: '您在使用动脉橙会员服务过程中，如遇任何使用问题，欢迎您随时联系我们。微信号：vcbeat_m，邮箱：liu.y@vcbeat.net。'
      },
      {
        title: '特别声明',
        text: '动脉橙会员服务为虚拟内容服务，请于购买前详细了解，无法定或约定事由概不退款， 最终解释权归动脉橙所有，敬请理解。'
      },
      {
        title: '动脉橙会员可以在哪些平台购买？',
        text: '您可以选择动脉橙PC端、动脉网公众号（Android端)，目前动脉网公众号（iOS端）暂不支持虚拟支付。'
      }
      ],
      // open_list: [], // 已打开的qa_item
      price_arr: [], // 价格数组

      is_valid_nopay: false, // 是否验证过有未支付会员订单
      nopay_list: [], // 未支付订单
      message_model: false, // 未支付订单模态框

      animation: false, // 动画效果

      num_5: 0,
      num_10: 0,
      num_20: 0,
      num_50: 0,
      num_100: 0,
      time_s: 5
    }
  },
  components: {
    FinishInfoAndPay, AddApply
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
    user() {
      if (this.$store.state.user && typeof this.$store.state.user == 'string') {
        return JSON.parse(this.$store.state.user)
      } else {
        return this.$store.state.user
      }
    },
    static_img_url() {
      return this.$store.state.static_img_url
    },
    theme_switch() {
      return this.$store.state.theme_switch
    }
  },
  methods: {
    // isOpen(index) {
    //   if (this.open_list.indexOf(index) == -1) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    // openClose(index) { // 点击操作
    //   let idx = this.open_list.indexOf(index)
    //   if (idx == -1) {
    //     this.open_list.push(index)
    //   } else {
    //     this.open_list.splice(idx, 1)
    //   }
    // },
    clearModal2BodyStyle() {
      document.body.style.paddingRight = ''
      document.body.style.overflow = ''
    },
    isLoginOrVip2() {
      this.haddleApplyTry('温馨提示', '动脉橙产品升级中，现暂停VIP会员购买功能，已购买的会员将继续提供相关服务，欢迎申请动脉橙企业智库机构版进行免费试用。', 29)
    },
    async isLoginOrVip() {
      if (!this.user_key) {
        this.login()
        return
      }
      if (!this.is_valid_nopay) {
        await this.noPayOrderList()
        if (this.nopay_list.length != 0) {
          return
        }
      }
      // this.$refs['finish_info_and_pay'].showInfo(4, 'VIP会员')
      // return
      // this.$refs['finish_info_and_pay'].showInfo(4, 'VIP会员')
      if (this.user.name && this.user.compName && this.user.title) {
        this.$refs['finish_info_and_pay'].showInfo(2, 'VIP会员')
      } else {
        this.$refs['finish_info_and_pay'].showInfo(1, 'VIP会员')
      }
    },
    async getMeta() { // 获取元数据
      let res = await getMeta({
        name: ['vip_type']
      }, (error) => {
        this.$Message.error('元数据请求错误！')
      })
      if (res.status == 'success') {
        this.price_arr = res.meta.vip_type
      } else {
        this.$Message.error(res.message)
      }
    },
    async noPayOrderList() { // 检查是否有订单未完成
      let res = await noPayOrderList({
        user_key: this.$store.state.user_key,
        page: '1',
        type: '8'
      }, (error) => {
        this.$Message.error('订单验证请求错误！')
      })
      if (res.status == 'success') {
        if (res.res.length != 0) {
          this.nopay_list.push(res.res[0])
          this.message_model = true
        }
      } else {
        this.$Message.error(res.message)
      }
      this.is_valid_nopay = true
    },
    goPayNoPayOrder() { // 去支付未支付订单
      this.message_model = false
      this.$refs['finish_info_and_pay'].showInfo(3, 'VIP会员')
    },
    async cancelOrder() {
      let res = await cancelOrder({
        user_key: this.$store.state.user_key,
        uid: this.nopay_list[0].uid,
        type: '8'
      }, (error) => {
        this.$Message.error('订单验证请求错误！')
      })
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    },
    handleClickTabBtn() {
      if (this.user_key) {
        const {
          href
        } = this.$router.resolve({
          name: "SpecialList",
        })
        window.open(href, '_blank')
      } else {
        this.login()
      }
    }
  },
  created() {
    this.getAddPuv()
    this.getMeta()

    this.$nextTick(() => {
      window.onscroll = () => {
        let scrollTop = 0
        if (document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop;
        } else if (document.body) {
          scrollTop = document.body.scrollTop;
        }
        if (scrollTop > 500 && !this.animation) {
          this.animation = true
          let numInterval = setInterval(() => {
            if (this.num_5 == this.time_s) {
              clearInterval(numInterval)
              return
            }
            this.num_5 = this.num_5 + 1
            this.num_10 = this.num_10 + 2
            this.num_20 = this.num_20 + 4
            this.num_50 = this.num_50 + 10
            this.num_100 = this.num_100 + 20
          }, 400)
        }
      }
    })

  },
  mounted() {
    this.isLoginOrVip2()
    if (this.$store.state.user_key) {
      this.noPayOrderList()
    }
  },
  beforeDestroy() {
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
commonBgColor1(color_d, color_l)
  [data-theme='dark'] &
    background-color color_d
  [data-theme='light'] &
    background-color color_l
#buyvip
  commonBgColor(inherit, #ffffff)
  padding-bottom 98px
.banner
  display flex
  justify-content center
  overflow hidden
  img
    height 300px
.vip-container
  width 1200px
  margin 12px auto 0
  commonBgColor(#181A23, #FFFFFF)
  .privilege-list
    display flex
    flex-wrap wrap
    margin-top 40px
    border-left 1px solid
    border-top 1px solid
    commonBorderColor(#2A2F42, #EEEEEE)
    commonBgColor(#1F2330, #FFFFFF)
    >div
      display flex
      flex 0 0 33.33%
      flex-wrap wrap
      align-items center
      padding 40px 0
      border-right 1px solid
      border-bottom 1px solid
      commonBorderColor(#2A2F42, #EEEEEE)
      padding-left 100px
      img
        display block
        width 66px
        height 66px
      > div
        margin-left 20px
        p:nth-child(1)
          font-size 22px
          font-weight bold
          commonBgColor(linear-gradient(270deg, rgba(101, 101, 101, 1) 0%, rgba(202, 163, 98, 1) 0%, rgba(221, 189, 130, 1) 100%), linear-gradient(270deg, rgba(101, 101, 101, 1) 0%, rgba(202, 163, 98, 1) 0%, rgba(221, 189, 130, 1) 100%))
          -webkit-background-clip text !important
          -webkit-text-fill-color transparent
        p:nth-child(2)
          font-size 16px
          margin-top 10px
          commonColor(#e9e9e9, #333333)
      &.last-li
        flex 0 0 99.99%
        padding 20px 0
        font-weight bold
        text-align center
        justify-content center
        font-size 14px
        background linear-gradient(270deg, rgba(101, 101, 101, 1) 0%, rgba(202, 163, 98, 1) 0%, rgba(221, 189, 130, 1) 100%)
        -webkit-background-clip text
        -webkit-text-fill-color transparent
  .pause
    width 1080px
    height 42px
    background #FFF7F1
    border-radius 21px
    display flex
    align-items center
    justify-content: center
    margin 0 auto 30px
    p
      font-size 16px
      color #FA5A00
      line-height 1
      margin 0 12px
    span
      color #6888F8
      cursor pointer
    .icon
      width 14px
      height 14px
      border 1px solid #FA5A00
      border-radius: 50%
      display flex
      align-items center
      justify-content: center
      &:before
        content ''
        width 8px
        height 8px
        background #FA5A00
        border-radius: 50%
  .vip-tabs
    display flex
    width 100%
    height 180px
    >div
      width 580px
      height 180px
      commonBgColor(#1F2330, #ffffff)
      commonShadow(0px 8px 20px 0px rgba(0, 0, 0, 0.3), 0px 4px 20px 0px rgba(121, 133, 143, 0.1))
      padding 30px 30px 20px
      position relative
      &.left
        commonBgColor1(#1f2330, #ffffff)
        background-image url('~pic/buyvip/dg-left.png')
        background-repeat no-repeat
        background-size 163px 168px
        background-position top right
        .one
          font-size 36px
          color #188ded
        .two
          width 130px
          height 2px
          background #188ded
          margin-top 20px
        .three
          position absolute
          font-size 18px
          
          font-weight 500
          color #188ded
          left 30px
          bottom 20px
        .four
          position absolute
          right 30px
          top 30px
          width 120px
          height 40px
          background #188ded
          border-radius 20px
          line-height 40px
          font-size 16px
          color #fff
          text-align center
          cursor pointer
          &:hover
            background #69c0ff
      &.right
        commonBgColor1(#1f2330, #ffffff)
        background-image url('~pic/buyvip/dg-right.png')
        background-repeat no-repeat
        background-size 163px 168px
        background-position top right
        margin-left 40px
        .one
          font-size 36px
          color #FFE5B6
          background linear-gradient(0deg, rgba(101, 101, 101, 1) 0%, rgba(203, 168, 123, 1) 0%, rgba(255, 229, 182, 1) 100%)
          -webkit-background-clip text
          -webkit-text-fill-color transparent
        .two
          width 130px
          height 2px
          background #E7C191
          margin-top 20px
        .three
          position absolute
          font-size 18px
          
          font-weight 500
          color #D8B06C
          left 30px
          bottom 20px
          >span
            vertical-align text-bottom
            span:nth-child(1)
              font-size 16px
            span:nth-child(2)
              font-size 26px
            span:nth-child(3)
              font-size 14px
              commonColor(#CECECE, #666)
            span:nth-child(4)
              font-size 16px
              color #999999
              text-decoration line-through
            img
              width 32px
              height 14px
              vertical-align text-top
              margin-bottom 5px
              margin-right -15px
              margin-top -5px
            &+span
              margin-left 30px
              span:nth-child(2)
                font-size 20px
        .four
          position absolute
          right 30px
          top 30px
          width 120px
          height 40px
          background #E2E2E2
          border-radius 20px
          line-height 40px
          font-size 16px
          color #fff
          text-align center
          cursor pointer
.vip-wechat-title
  margin 60px 0
  font-size 36px
  commonColor(#ffffff, #333333)
  font-weight bold
  text-align center
  i
    font-size 16px
    color #188ded
    &.left
      vertical-align text-top
      margin-right 10px
    &.right
      vertical-align text-bottom
      margin-left 10px
.qa-list
  display flex
  flex-wrap wrap
  margin-top 40px
  border-left 1px solid
  border-top 1px solid
  commonBorderColor(#2A2F42, #EEEEEE)
  commonBgColor(#1F2330, #FFFFFF)
  .qa-item
    flex 0 0 50%
    border-bottom 1px solid
    border-right 1px solid
    height 180px
    commonBorderColor(#2A2F42, #EEEEEE)
    padding 40px 30px 0 30px
    p
      position relative
      padding-left 28px
      &:before
        content ''
        position absolute
        width 18px
        height 18px
        background-image url('~pic/buyvip/q-icon.png')
        background-size 18px 18px
        background-repeat no-repeat
        left 0
        top 0
    p:nth-child(1)
      font-size 18px
      display flex
      commonColor(#ffffff, #333333)
      justify-content space-between
    p:nth-child(2)
      font-size 16px
      commonColor(#BCBDC1, #666666)
      line-height 24px
      margin-top 16px
      &:before
        background-image url('~pic/buyvip/a-icon.png')
        top 3px
.black-board
  height 172px
  width 1200px
  margin 50px auto 0
  border-top 6px #40444F solid
  commonBorderColor(#40444F, #e9e9e9)
  padding-left 130px
  display flex
  align-items center
  p:nth-child(1)
    color #BCBDC1
    font-size 40px
  p:nth-child(2)
    margin 0 40px
    font-size 40px
    color #BCBDC1
  p:nth-child(3)
    font-size 16px
    color #BCBDC1
    line-height 20px
    max-width 600px
.fixed-float
  height 58px
  commonBgColor(rgba(0, 0, 0, 0.8), rgba(51, 51, 51, 0.9))
  width 100%
  position fixed
  bottom 0
  left 0
  .fixed-area
    height 100%
    width 1200px
    margin 0 auto
    display flex
    justify-content space-between
    align-items center
    position relative
    >p
      font-size 18px
      color #FFFFFF
      margin-top 4px
      img
        margin -4px 20px 0 20px
        vertical-align middle
    >div
      // padding: 22px 30px;
      width 211px
      height 70px
      background-image url('~pic/buyvip/become-vip-bg.png')
      background-size 211px 70px
      background-repeat no-repeat
      cursor pointer
      position absolute
      right 0
      top -12px
      &:hover
        background-image url('~pic/buyvip/become-vip-bg-hover.png')
      p
        color #fff
        font-size 20px
        text-align center
        margin-left 15px
        line-height 70px
        font-weight bold
        // span:nth-child(1)
        // font-size: 22px;
        // span+span
        // margin-left: 15px;
.sub-title
  margin-top 40px
  display flex
  justify-content center
  align-items center
.sub-title div
  width 7px
  height 7px
  background linear-gradient(-45deg, #188ded, #F5FBFF)
  transform rotate(135deg)
.sub-title p
  font-size 24px
  commonColor(#fff, #333)
  font-weight bold
  margin 0 10px
.module-two
  padding 0 56px
  margin-top 40px
  commonBgColor(#1F2330, #ffffff)
  border 1px solid
  commonBorderColor(#2A2F42, #EEEEEE)
.module-two__area
  padding 30px 0
.module-two__area+.module-two__area
  border-top 1px solid
  commonBorderColor(#2A2F42, #f3f3f3)
.module-two__area>p
  text-align center
  font-size 20px
  font-weight bold
  commonColor(#ffffff, #333333)
.compare
  display flex
  margin-bottom 30px
.compare i
  margin 10px 20px 0
  font-size 32px
  commonColor(#FFFFFF, #666666)
  padding 20px
  border-radius 50%
  border 1px #666666 solid
.compare .left, .compare .right
  flex 1
  color #666666
.compare .left>p
  vertical-align text-bottom
  font-size 24px
  commonColor(#E9E9EB, #666666)
  margin-top 8px
.compare .left>p span
  font-size 14px
.compare .left>p.zanbu, .compare .right>p.zanbu
  margin-top 14px
  font-size 18px
.compare .left>div
  width 100%
  height 6px
  position relative
  commonBgColor(#2A2F42, #F4F4F4)
  border-radius 3px 0px 0px 3px
  margin-top 12px
.compare .left>div div
  position absolute
  height 6px
  top 0
  right 0
  commonBgColor(linear-gradient(-90deg, rgba(24, 141, 237, 1), rgba(17, 42, 62, 1)), linear-gradient(-90deg, rgba(24, 141, 237, 1), rgba(245, 251, 255, 1)))
  border-radius 3px 0px 0px 3px
transition()
  transition all 2s
.compare
  .left
    >div
      .length1, .length2, .length3
        transition()
        width 0
      .length1.animation
        width 180px
      .length2.animation
        width 320px
      .length3.animation
        width 100px
// .compare .left>div .length1 {
// width: 180px;
// }
// .compare .left>div .length2 {
// width: 320px;
// }
.compare .right>p
  vertical-align text-bottom
  font-size 24px
  text-align right
  margin-top 12px
  commonColor(#E9E9EB, #666666)
.compare .right>div
  width 100%
  height 6px
  position relative
  commonBgColor(#2A2F42, #F4F4F4)
  border-radius 0 3px 3px 0
  margin-top 12px
.compare .right>div div
  width 0
  height 6px
  position absolute
  top 0
  left 0
  commonBgColor(linear-gradient(270deg, rgba(54, 46, 33, 1), rgba(221, 189, 130, 1)), linear-gradient(270deg, rgba(255, 249, 238, 1), rgba(255, 229, 182, 1)))
  transition()
  border-radius 0 3px 3px 0
.compare .right>div div.animation
  width 100%
.module-two__area-item
  margin-top 20px
.module-two__area-item>p
  text-align center
.module-two__area-item>p+p
  margin-top 20px
.module-two__area-item .p1
  font-size 18px
  commonColor(#E9E9EB, #333333)
.module-two__area-item .p2
  font-size 14px
  commonColor(#BCBDC1, #666666)
.module-two__area-item .p2.br
  line-height 22px
</style>
